(function () {
    'use strict';

    function ActivityTypeSelectorComponentController($scope, $state, ActivityTypeInfo, ActivityTypeInfoCustom) {
        //

        var $ctrl = this;
        $ctrl.activityTypes = [];
        $ctrl.loadAll = loadAll;

        loadAll();

        function loadAll() {
            loadAllActivityTypes();
        }

        function loadAllActivityTypes() {

            ActivityTypeInfoCustom.getAllActivityTypeInfos().query(function (result) {
                $ctrl.activityTypes = result;
                categorizeActivityTypes();
            });
        }

        function categorizeActivityTypes() {

            $ctrl.typeCategories = [];

            $ctrl.beauty = {};
            $ctrl.beauty.title = 'زیبایی';
            $ctrl.beauty.items = [];

            $ctrl.health = [];
            $ctrl.health.title = 'سلامتی';
            $ctrl.health.items = [];

            $ctrl.serviceBase = [];
            $ctrl.serviceBase.title = 'خدماتی';
            $ctrl.serviceBase.items = [];

            $ctrl.education = [];
            $ctrl.education.title = 'آموزشی';
            $ctrl.education.items = [];

            $ctrl.entertainment = [];
            $ctrl.entertainment.title = 'تفریحی ورزشی';
            $ctrl.entertainment.items = [];

            $ctrl.enterprise = [];
            $ctrl.enterprise.title = 'سازمان و شرکت';
            $ctrl.enterprise.items = [];

            if ($ctrl.activityTypes) {
                angular.forEach($ctrl.activityTypes, function (item) {

                    switch (item.category) {
                        case 'BEAUTY' :
                            $ctrl.beauty.items.push(item);
                            break;
                        case 'HEALTH' :
                            $ctrl.health.items.push(item);
                            break;
                        case 'EDUCATION' :
                            $ctrl.education.items.push(item);
                            break;
                        case 'ENTERTAINMENT' :
                            $ctrl.entertainment.items.push(item);
                            break;
                        case 'SERVICE_BASE' :
                            $ctrl.serviceBase.items.push(item);
                            break;
                        case 'ENTERPRISE' :
                            $ctrl.enterprise.items.push(item);
                            break;

                    }
                })

                $ctrl.typeCategories.push($ctrl.beauty);
                $ctrl.typeCategories.push($ctrl.health);
                $ctrl.typeCategories.push($ctrl.serviceBase);
                $ctrl.typeCategories.push($ctrl.education);
                $ctrl.typeCategories.push($ctrl.enterprise);
                $ctrl.typeCategories.push($ctrl.entertainment);


            }
        }

    }

    var ActivityTypeSelectorComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/activity-type-selector/partial-form.activity-type-selector.html',
        controller: ActivityTypeSelectorComponentController,
        bindings:
            {
                activityType: '=',
                isRequired: '='
            }

    };

    angular
        .module('tikonApp')
        .component('pfActivityTypeSelector', ActivityTypeSelectorComponent)

    ActivityTypeSelectorComponentController.$inject = ['$scope', '$state', 'ActivityTypeInfo', 'ActivityTypeInfoCustom'];


})();

